import { render, staticRenderFns } from "./RolCopyModal.vue?vue&type=template&id=7703df0e&scoped=true&"
import script from "./RolCopyModal.vue?vue&type=script&lang=js&"
export * from "./RolCopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7703df0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7703df0e')) {
      api.createRecord('7703df0e', component.options)
    } else {
      api.reload('7703df0e', component.options)
    }
    module.hot.accept("./RolCopyModal.vue?vue&type=template&id=7703df0e&scoped=true&", function () {
      api.rerender('7703df0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/roles/RolCopyModal.vue"
export default component.exports